module.exports = __webpack_public_path__ + "img/IMG_2254_L_BlackMatted_MockedUp.3fda73dc.jpg";